module.exports = __webpack_public_path__ + "img/estimated-insurance-required-input.2eaf9494.svg";